import {
  Button,
  Colors,
  Icon,
  Menu,
  MenuDivider,
  MenuItem,
  Popover,
  PopoverInteractionKind,
  Position
} from '@blueprintjs/core'
import cx from 'classnames'
import { lang } from 'enablex/shared'
import React, { FC, useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'

import { AppState } from '~/app/rootReducer'
import BasicAuthentication from '~/auth/basicAuth'
import KeyIcon from '~/icons/KeyIcon'
import LogoutIcon from '~/icons/LogoutIcon'
import UserIcon from '~/icons/UserIcon'
import ChangeLanguage from '~/user/ChangeLanguage'
import { fetchProfile } from './reducer'
import style from './style.scss'
import UpdatePassword from './UpdatePassword'
import UserProfile from './UpdateUserProfile'

type Props = ConnectedProps<typeof connector>

const UserDropdownMenu: FC<Props> = props => {
  const [isProfileOpen, setProfileOpen] = useState(false)
  const [isPasswordOpen, setPasswordOpen] = useState(false)
  const [isLanguageOpen, setLanguageOpen] = useState(false)

  useEffect(() => {
    !props.profile && props.fetchProfile()
  }, [])

  const logout = async () => {
    const auth: BasicAuthentication = new BasicAuthentication()
    await auth.logout()
  }

  if (!props.profile) {
    return null
  }

  const toggleProfile = () => setProfileOpen(!isProfileOpen)
  const togglePassword = () => setPasswordOpen(!isPasswordOpen)
  const toggleLanguage = () => setLanguageOpen(!isLanguageOpen)

  const { email, fullName, strategyType, picture_url, isEnablexAdmin, isSuperAdmin } = props.profile
  const canChangePassword = strategyType === 'basic'

  const icon = picture_url ? (
    <img src={picture_url} className={cx('dropdown-picture', style.dropdown_picture)} />
  ) : (
    <UserIcon style={{ border: '1px solid #333', borderRadius: '50%', padding: '2px', width: '24px', height: '24px' }} strokeWidth="2"/>
  )

  return (
    <div>
      <Popover minimal position={Position.BOTTOM} interactionKind={PopoverInteractionKind.CLICK}>
        <Button className={style.profileButtonWrapper} id="btn-menu-user-dropdown" style={{border: '1px solid #efefef', borderRadius: '8px'}} icon={icon} minimal text={<span style={{ fontSize: '12px', fontFamily: 'Barlow SemiBold', color: '#666666' }}>{email}</span>} />
        <Menu>
          <MenuDivider title={lang.tr('admin.signedInAs', { name: email })} />
          <MenuItem id="btn-profile" icon={<UserIcon  strokeWidth="2"/>} text={lang.tr('admin.updateProfile')} onClick={toggleProfile} />

          {canChangePassword && !isEnablexAdmin && (
            <MenuItem id="btn-changepass" icon={<KeyIcon />} text={lang.tr('admin.changePassword')} onClick={togglePassword} />
          )}

          {/* <MenuItem
            id="btn-changeLanguage"
            icon="translate"
            text={lang.tr('admin.changeLanguage')}
            onClick={toggleLanguage}
          /> */}

          <MenuDivider />
          <MenuItem id="btn-logout" icon={<LogoutIcon />} text={lang.tr('admin.logout')} onClick={logout} />
        </Menu>
      </Popover>

      <UpdatePassword profile={props.profile} isOpen={isPasswordOpen} toggle={togglePassword} />

      <UserProfile
        isOpen={isProfileOpen}
        toggle={toggleProfile}
        profile={props.profile}
        fetchProfile={props.fetchProfile}
      />

      <ChangeLanguage isOpen={isLanguageOpen} toggle={toggleLanguage} />
    </div>
  )
}

const mapStateToProps = (state: AppState) => ({ profile: state.user.profile })
const connector = connect(mapStateToProps, { fetchProfile })

export default connector(UserDropdownMenu)
